import React from "react";
import { useState } from "react";
import ContainerContent from "../Container/ContainerContent";
import { API, Auth, Storage } from "aws-amplify";
import AWS from "aws-sdk";
import CSVReader from "react-csv-reader";
import Lottie from "react-lottie";
import Loading from "../../animation/loading.json";
import _ from "lodash";

function ModelMain() {
  const [loadingImport, setLoadingImport] = useState(false);
  const [error, setError] = useState(null);

  const onImportModel = (type) => async (importDatas, fileInfo) => {
    try {
      setLoadingImport(true);

      if (importDatas.length > 0) {
        // Brand
        const importBrand = importDatas[0];

        const brand_name = importBrand?.BRAND;
        // const { brand } = await API.get(
        //   "MoneyHubAdmin",
        //   `/brand/${importBrand.BRAND}`,
        //   {
        //     queryStringParameters: {
        //       type,
        //     },
        //     headers: {
        //       Authorization: `Bearer ${(await Auth.currentSession())
        //         .getIdToken()
        //         .getJwtToken()}`,
        //     },
        //   }
        // );
        // if (!brand) {

        if (importBrand.BRAND) {
          await API.post("MoneyHubAdmin", `/brand`, {
            queryStringParameters: {},
            body: {
              brand_name: importBrand.BRAND,
              type,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        }
        // }

        // Model
        const modelGroups = _.groupBy(importDatas, "MODEL");
        const modelGroupsKeys = Object.keys(modelGroups);
        for (const modelGroupsKey of modelGroupsKeys) {
          // const { model } = await API.get("MoneyHubAdmin", `/model`, {
          //   queryStringParameters: {
          //     brand_name: brand_name,
          //     model_name: modelGroupsKey,
          //     type,
          //   },
          //   headers: {
          //     Authorization: `Bearer ${(await Auth.currentSession())
          //       .getIdToken()
          //       .getJwtToken()}`,
          //   },
          // });
          // if (!model) {

          if (modelGroupsKey) {
            await API.post("MoneyHubAdmin", `/model`, {
              queryStringParameters: {},
              body: {
                brand_name: brand_name,
                model_name: modelGroupsKey,
                type,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });
          }
          // }

          const groupYears = _.groupBy(modelGroups[modelGroupsKey], "YEAR");
          const groupYearsKeys = Object.keys(groupYears);
          for (const groupYearsKey of groupYearsKeys) {
            // const { year } = await API.get("MoneyHubAdmin", `/year`, {
            //   queryStringParameters: {
            //     year: `${groupYearsKey}`,
            //     model_name: modelGroupsKey,
            //     type,
            //   },
            //   headers: {
            //     Authorization: `Bearer ${(await Auth.currentSession())
            //       .getIdToken()
            //       .getJwtToken()}`,
            //   },
            // });
            // if (!year) {

            if (groupYearsKey && brand_name && modelGroupsKey) {
              await API.post("MoneyHubAdmin", `/year`, {
                queryStringParameters: {},
                body: {
                  year: `${groupYearsKey}`,
                  brand_name: brand_name,
                  model_name: modelGroupsKey,
                  type,
                },
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getIdToken()
                    .getJwtToken()}`,
                },
              });
            }

            // }
          }
        }

        // SubModel
        for (const importData of importDatas) {
          // if (importData.SUB_MODEL) {
            await API.post("MoneyHubAdmin", `/subModel`, {
              queryStringParameters: {},
              body: {
                type,
                subModel_name: `${_.trim(importData.SUB_MODEL, "") || importData?.MODEL}`,
                year: `${importData?.YEAR}`,
                brand_name: `${importData?.BRAND}`,
                model_name: `${importData?.MODEL}`,
                gear_type: `${importData?.GEAR_TYPE || "AUTOMATIC"}`,
                desc: importData?.DESC || "",
                t_price: importData?.T_PRICE || 0,
                nt_price: importData?.NT_PRICE || 0,
                new_price: importData?.NEW_PRICE,
                // broken_year_one: importData.BROKEN_YEAR_ONE,
                // broken_year_two: importData.BROKEN_YEAR_TWO,
                // broken_year_three: importData.BROKEN_YEAR_THREE,
                // broken_year_four: importData.BROKEN_YEAR_FOUR,
                // broken_year_five: importData.BROKEN_YEAR_FIVE,
              },
              headers: {
                Authorization: `Bearer ${(await Auth.currentSession())
                  .getIdToken()
                  .getJwtToken()}`,
              },
            });
          // }
        }
      }

      console.log("importDatas", importDatas);
    } catch (error) {
      console.log("import model error", error);
      setError(error);
      alert("Import failed");
    } finally {
      setLoadingImport(false);
    }
  };

  const importOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
  };

  return (
    <ContainerContent>
      {loadingImport && (
        <div className="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-70 backdrop-filter backdrop-blur-sm flex justify-center items-center    ">
          <div className="w-2/5 h-auto mx-auto  ">
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: Loading,
                isStopped: false,
                isPaused: false,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
            />
            <div className="text-center text-white text-xl">
              กำลัง Sync ข้อมูล CSV กับ Transactions{" "}
            </div>
          </div>
        </div>
      )}
      <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
        <div className="ml-2 flex flex-row space-x-4">
          <label className="my-auto font-bold text-gray-700">
            Import Model (รถยนต์)
          </label>
          <CSVReader
            parserOptions={importOptions}
            onFileLoaded={onImportModel("CAR")}
          />
        </div>{" "}
      </div>
      <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
        <div className="ml-2 flex flex-row space-x-4">
          <label className="my-auto font-bold text-gray-700">
            Import Model (จักรยานยนต์)
          </label>
          <CSVReader
            parserOptions={importOptions}
            onFileLoaded={onImportModel("MOTORBIKE")}
          />
        </div>{" "}
      </div>
      <div className="mx-4  p-2 lg:flex bg-gray-50 mb-2 border border-gray-200">
        <div className="ml-2 flex flex-row space-x-4">
          <label className="my-auto font-bold text-gray-700">
            Import Model (รถกระบะ)
          </label>
          <CSVReader
            parserOptions={importOptions}
            onFileLoaded={onImportModel("TRUCK")}
          />
        </div>{" "}
      </div>
    </ContainerContent>
  );
}

export default ModelMain;
